import { Typography } from 'antd';

function NotFound() {
  return <Typography.Text>404 - Page Not Found</Typography.Text>;
}

export default NotFound;
